import React from "react";
import "../css/forgotPasswordOTP.css"
import { NavLink } from "react-router-dom";

function ForgotPasswordOTP() {

    return (

        <div>
            <div className="forgotPasswordOTP-bg_img"></div>
            <div className="forgotPasswordOTP-div">
                <div className="forgotPasswordOTP-content">
                    <h2 className="forgotPasswordOTP-heading">Enter 4 Digits OTP</h2>
                    <p className="forgotPasswordOTP-msg">Enter the 4 digits otp that you recieved on your email.</p>
                    
                    <NavLink className="forgotPasswordOTP-continueNavlink" to="/resetPasswordForm"><button type="button" className="forgotPasswordOTP-continueBtn">CONTINUE</button></NavLink>
                </div>
            </div>
        </div>

    );
}


export default ForgotPasswordOTP